import { HailingReceipt, PublicDashOrder } from "../../../models/receipt/dashOrder";

// txId is the receipt URL's id, the HAILING_REQUEST tx id the /v2 cancel routes take;
// order.id is the order-group id, which they reject.
export const toHailingReceipt = (order: PublicDashOrder, txId: string): HailingReceipt => {
  const contact = order.supportContact;
  return {
    id: txId,
    status: order.status,
    time: order.request?.time,
    updatedAt: order.updatedAt,
    tripItinerary: order.itinerary.map((p) => ({
      lat: p.lat,
      lng: p.lng,
      index: p.index,
      placeId: p.placeId ?? "",
      i18n: p.i18n ?? {},
    })),
    paymentInformation: {
      cardNumber: order.payment?.cardSuffix ?? "",
      paymentMethod: order.payment?.cardType ?? "",
    },
    driver: order.driver
      ? {
          name: order.driver.name ?? "",
          nameZh: order.driver.nameTc ?? "",
          phoneNumber: order.driver.phoneNumber ?? "",
          licensePlate: order.vehicle?.licensePlate ?? "",
          vehicle: {
            make: order.vehicle?.make ?? "",
            model: order.vehicle?.model ?? "",
            iconUrl: order.vehicle?.imageUrl ?? "",
          },
        }
      : undefined,
    total: order.userTotal ?? 0,
    cancellationFee: order.billing?.cancellationFee ?? 0,
    eta: order.live?.eta ?? null,
    driverLocation: order.live?.driverLocation ?? null,
    driverRoutePolyline: order.live?.routeEncodedPolyline ?? null,
    tripEstimationPolyline: order.tripEstimation?.encodedPolyline ?? null,
    clientType: order.clientType,
    hotelPhone: contact?.isShown === true && contact.phoneNumber ? contact.phoneNumber : "",
  };
};
